import type React from "react";

import { useRoutes } from "react-router-dom";

import { ServicesFormView } from "routes/calendar/views/Services/ServiceFormView";
import { Container } from "shared/atoms/Container";
import { usePageContentOffsetTop } from "shared/styles/usePageContentOffsetTop";

import { CalendarView } from "./views/CalendarView";
import { ServicesView } from "./views/Services";

export const CalendarRoutes: React.FC = () => {
  const offsetTop = usePageContentOffsetTop();
  const routes = useRoutes([
    {
      path: "/",
      element: (
        <Container $pageContentOffsetTop={offsetTop}>
          <CalendarView />
        </Container>
      ),
    },
    {
      path: "/services",
      element: (
        <Container $pageContentOffsetTop={offsetTop}>
          <ServicesView />
        </Container>
      ),
    },
    {
      path: "/services/new",
      element: (
        <Container $pageContentOffsetTop={offsetTop}>
          <ServicesFormView />
        </Container>
      ),
    },
    {
      path: "/services/edit/:serviceId",
      element: (
        <Container $pageContentOffsetTop={offsetTop}>
          <ServicesFormView />
        </Container>
      ),
    },
  ]);

  return routes;
};
